var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('star-rating',{attrs:{"rating":_vm.rating,"show-rating":false,"star-size":40,"active-color":"#000","inactive-color":"#DDE2E6","inline":_vm.inline},on:{"rating-selected":function($event){_vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }